import {EntityStoreService} from '../modules/akita-mimic/services/entity-store.service';
import {DocumentState} from '../modules/akita-mimic/models/store-states/document-state.model';
import {Document} from '../api/models/document';
import {Injectable} from '@angular/core';
import {DocumentViewModeEnum} from '../enums/document-view-mode.enum';

@Injectable({ providedIn: 'root' })
export class DocumentStore extends EntityStoreService<DocumentState, Document> {
    public constructor() {
        super('document', {
            active: [],
            entities: {},
            ids: [],
            loading: false,
            selected: undefined,
            loadingErrorSelectedDocumentId: undefined,
            currentPreviewPage: 1,
            documentTypeCategories: [],
            documentTypes: [],
            documentViewMode: DocumentViewModeEnum.Viewing,
            imageSize: {
                x: 0,
                y: 0
            }
        });
    }
}
